
        <div class="row" [hidden]="msgHead.msg == ''">
            <div class="col-lg-8 col-md-6 col-xs-12">
                <alert [alert]="msgHead"></alert>
            </div>
        </div>
        <div *ngIf="hasAccess" class="row">
            <div class="col-lg-6 col-md-6 col-xs-12">
                <alert [alert]="msg" style="display:block;"></alert>
            </div>
        </div>
        <div *ngIf="hasAccess" class="row">
            <div class="col-lg-8 col-md-7 col-xs-12">
                <button type="button" class="btn btn-large btn-primary" (click)="add()">Add New</button>
                <button type="button" class="btn btn-large btn-deny" style="margin-left:5px;" (click)="refresh()">Refresh</button>
				</div>
				<div class="col-lg-4 col-md-5 col-xs-8">
					<div class="input-group">
						<input class="form-control" type="text" (keyup.enter)="refresh()" [(ngModel)]="fobj.query" placeholder="Search"/>
						<span class="input-group-btn">
							<button class="btn btn-default" type="button" (click)="refresh()"> <span class="glyphicon glyphicon-search"></span> </button>
						</span>
					</div>
					<p style="text-align:right">
						<a style="cursor: pointer;" (click)="deleteAllConfirmation()">delete all</a>
					</p>
				</div>
				<div class="row" [hidden]="msgYesNo.msg == ''">
					<div class="col-lg-8 col-md-6 col-xs-12">
						<alert-yesno [alert]="msgYesNo" (respond)="msgYesNoRespond($event)" style="display:block;margin-top:10px;"></alert-yesno>
					</div>
		 		</div>
		    <div class="col-lg-12 col-md-12 col-xs-12">
                <div class="card">
                    <table class="table">
                        <thead>
                            <tr>
                                <th>IdP Name</th>
                                <th>Username</th>
                                <th>First Name</th>
                                <th>Last Name</th>
										  <th>Card ID</th>
										  <th>Group Names</th>
										  <th>Created At</th>
										  <th>Last Login At</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let row of data; let i = index">
                                <td style="width:10%;">{{ row.idpName }}</td>
                                <td style="width:15%;">{{ row.username }}</td>
                                <td style="width:10%;">{{ row.firstName }}</td>
                                <td style="width:10%;">{{ row.lastName }}</td>
								<td style="width:8%;">{{ row.cardId }}</td>
								<td style="width:10%;">
									<span title="{{ row.groupNames }}" (click)="expandGroupName(row)" [style.cursor]="cursorStyle(row)">{{ truncateText(row) }}</span>
								</td>
                                <td style="width:12%;">{{ printDate(row.createdAt) }}</td>
								<td style="width:12%;">{{ printDate(row.lastLoginAt) }}</td>
                                <td style="width:15%;">
                                    <span title="Edit" class="btn-link" style="cursor: pointer;" (click)="edit(row)">Edit</span> |
                                    <span title="Roles" class="btn-link" style="cursor: pointer;" (click)="roles(row)">Roles</span> |
                                    <span title="Remove User" class="glyphicon glyphicon-trash" aria-hidden="true" (click)="remove(row)" style="cursor:pointer;"></span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
		  </div>
		  <div class="row" *ngIf="data.length > 0" style="">
            <div class="col-lg-5">
                <button class="btn btn-default" type="button" title="First Page" [disabled]="disablePreviousPage" (click)="firstPage()">&lt;&lt;</button>
                <button class="btn btn-default" type="button" title="Previous Page" [disabled]="disablePreviousPage" (click)="prevPage()">&lt;</button>
                <span>{{getFromPage()}}-{{getToPage()}} of {{rowCount}}</span>
                <button class="btn btn-default" type="button" title="Next Page" [disabled]="disableNextPage" (click)="nextPage()">&gt;</button>
            </div>
        </div>
    